import { apiRequest } from '../client';
import { toJsonSafe } from '../json';

export async function getStorefrontCompanyBySlug(slug) {
  const result = await apiRequest(`/api/public/companies/by-slug/${encodeURIComponent(slug)}`);
  return result.company || null;
}

export async function searchStorefrontCompanies(query) {
  const params = new URLSearchParams();
  if (query) params.set('q', query);
  const result = await apiRequest(`/api/public/companies/search?${params.toString()}`);
  return result.companies || [];
}

export async function checkPortalSlugAvailability(slug, excludeCompanyId) {
  const params = new URLSearchParams();
  if (excludeCompanyId) params.set('excludeCompanyId', excludeCompanyId);
  const query = params.toString();
  const path = `/api/public/portal-slugs/${encodeURIComponent(slug)}${query ? `?${query}` : ''}`;
  return apiRequest(path);
}

export async function listStorefrontBusySlots({ companyId, from, to }) {
  const params = new URLSearchParams();
  if (from) params.set('from', from instanceof Date ? from.toISOString() : String(from));
  if (to) params.set('to', to instanceof Date ? to.toISOString() : String(to));
  const result = await apiRequest(
    `/api/public/companies/${encodeURIComponent(companyId)}/busy-slots?${params.toString()}`
  );
  return result.slots || [];
}

export async function getPublicAppointment({ companyId, id }) {
  const result = await apiRequest(
    `/api/public/companies/${encodeURIComponent(companyId)}/appointments/${encodeURIComponent(id)}`
  );
  return result.appointment;
}

export async function getPublicAppointmentOrNull({ companyId, id }) {
  try {
    return await getPublicAppointment({ companyId, id });
  } catch (error) {
    if (error?.status === 404) return null;
    throw error;
  }
}

export async function getPublicPendingAppointment({ companyId, pendingId }) {
  const result = await apiRequest(
    `/api/public/companies/${encodeURIComponent(companyId)}/pending-appointments/${encodeURIComponent(pendingId)}`
  );
  return result.pending || null;
}

export async function getPublicPendingAppointmentOrNull({ companyId, pendingId }) {
  try {
    return await getPublicPendingAppointment({ companyId, pendingId });
  } catch (error) {
    if (error?.status === 404) return null;
    throw error;
  }
}

export async function createStorefrontAppointment({ companyId, appointment }) {
  const result = await apiRequest(`/api/public/companies/${encodeURIComponent(companyId)}/appointments`, {
    method: 'POST',
    body: { appointment: toJsonSafe(appointment) },
  });
  return result.appointment;
}
